module.exports = __webpack_public_path__ + "img/author-avatar-small-1.a6db9330.png";